import {
  CarryOutOutlined,
  FilterOutlined,
  SearchOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Menu,
  Popconfirm,
  Popover,
  Row,
  Select,
  Tooltip,
} from "antd";
import { FC, useEffect, useState } from "react";
import styles from "./index.module.scss";
import "./index.scss";
import { SearchAndFilterProps } from "./types";
import dayjs from "dayjs";
import { getApi, getApiCSV, getApiExcel } from "redux/apis";
import Export from "components/Global/Export";
import { toastText } from "utils/utils";
import moment from "moment";

const SearchAndFilter: FC<any> = (props) => {
  const {
    performSearchHandler,
    searchValue,
    onApply,
    handleServiceCenterChange,
    selectedServiceCenter,
    handleSparePartsChange,
    selectedSpareParts,
    handleFromDateChange,
    handleToDateChange,
    fromDate,
    toDate,
    handleSalesOrderNumberChange,
    selectedSalesOrderNumbers,
    handleStatusChange,
    selectedStatus,
    setFiltersReset,
    setSelectedStatus,
    handleFilterCall,
    clearFilter,
    salesOrderNumberOptions,
    fetchSalesOrderNumber,
    handleDeleteClick,
    selectedRowKeys,
    canDelete = false,
  } = props;

  const [selectedKey, setSelectedKey] = useState<"salesOrderNumber" | "status">(
    "salesOrderNumber"
  );

  const [serviceCenters, setServiceCenters] = useState<
    { value: string; label: string }[]
  >([]);
  const [spareParts, setSpareParts] = useState<
    { value: string; label: string }[]
  >([]);

  // Temporary state for filter selections (only applied on "Apply" click)
  const [tempSalesOrderNumbers, setTempSalesOrderNumbers] = useState<string[]>(
    []
  );
  const [tempStatus, setTempStatus] = useState<string[]>([]);

  // Initialize temp state with current parent state values
  useEffect(() => {
    setTempSalesOrderNumbers(selectedSalesOrderNumbers || []);
    setTempStatus(selectedStatus || []);
  }, [selectedSalesOrderNumbers, selectedStatus]);

  // const fetchSalesOrderNumber = async () => {
  //   try {
  //     const params = {
  //       serviceCenters: selectedServiceCenter || [],
  //     };
  //     const response = await getApi("/shipment/sales-order", {
  //       params,
  //     });
  //     if (Array.isArray(response.data.data) && response.data.data.length > 0) {
  //       setSalesOrderNumberOptions(
  //         response.data.data.map((item: any) => ({
  //           value: item.salesOrderNumber,
  //           label: item.salesOrderNumber,
  //         }))
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch sales order numbers:", error);
  //   }
  // };

  useEffect(() => {
    const fetchServiceCenters = async () => {
      try {
        const response = await getApi("/serviceCenter/shipment-dropdown");
        if (response.data.success) {
          setServiceCenters(
            response.data.data.map((center: any) => ({
              value: center.id,
              label: center.name,
            }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch service centers:", error);
      }
    };

    const fetchSpareParts = async () => {
      try {
        const response = await getApi("/shipment/getProducts?type=true");
        if (response.data.data.length > 0) {
          setSpareParts(
            response.data.data.map((item: any) => ({
              value: item.name,
              label: item.name,
            }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch items:", error);
      }
    };

    fetchServiceCenters();
    fetchSpareParts();
    fetchSalesOrderNumber();
  }, []);

  const handleMenuClick = (e: any) => {
    console.log("asdkhasjh", e.key);
    setSelectedKey(e.key);
  };

  const handleCancel = () => {
    setSelectedKey("salesOrderNumber");

    // Reset temp state to current parent state (no changes applied)
    setTempSalesOrderNumbers(selectedSalesOrderNumbers || []);
    setTempStatus(selectedStatus || []);
    handleReset();
  };

  const handleApplyFilters = () => {
    // Call the parent functions with callAPI=true to trigger API calls
    handleSalesOrderNumberChange(tempSalesOrderNumbers, true);
    handleStatusChange(tempStatus);
    handleFilterCall(tempSalesOrderNumbers, tempStatus);
    // onApply();
  };

  const salesOrderChange = (value: any) => {
    console.log(value);
    setTempSalesOrderNumbers(value || []);
    handleSalesOrderNumberChange(value, false);
  };
  const statusChange = (value: any) => {
    console.log(value);
    setTempStatus(value);
    handleStatusChange(value, false);
  };

  const handleReset = () => {
    setSelectedKey("salesOrderNumber");

    // Reset temp state
    setTempSalesOrderNumbers([]);
    setTempStatus([]);

    // Reset parent state with API calls
    handleSalesOrderNumberChange([], true);
    handleStatusChange([]);
    setFiltersReset(true);
    clearFilter();

    // Reset date filters if they exist
    if (handleFromDateChange) handleFromDateChange(null);
    if (handleToDateChange) handleToDateChange(null);
  };

  const items = [
    { key: "salesOrderNumber", label: "Sales Order" },
    { key: "status", label: "Status" },
  ];

  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row gutter={[8, 8]} align="middle" justify="space-between">
          <Col>
            <Row gutter={[8, 8]} align="middle">
              <Col>
                <Input
                  className={styles["search-filter__search"]}
                  placeholder="Search..."
                  suffix={<SearchOutlined />}
                  onChange={performSearchHandler}
                  value={searchValue}
                  size="large"
                />
              </Col>
              <Col>
                <Popconfirm
                  placement="rightBottom"
                  title={false}
                  rootClassName="filter-container"
                  description={
                    <div
                      className={styles["filer-content"] + " filter-content"}
                    >
                      <Menu
                        mode="vertical"
                        items={items}
                        onClick={handleMenuClick}
                        selectedKeys={[selectedKey]}
                        defaultSelectedKeys={[selectedKey]}
                      />

                      {selectedKey === "salesOrderNumber" && (
                        <div>
                          <Select
                            mode="multiple"
                            options={salesOrderNumberOptions}
                            placeholder="Select Sales Order"
                            value={tempSalesOrderNumbers}
                            maxTagCount="responsive"
                            maxTagTextLength={15}
                            onChange={(value) => {
                              salesOrderChange(value);
                              // setTempSalesOrderNumbers(value || []);
                            }}
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input: string, option?: any) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      )}

                      {selectedKey === "status" && (
                        <div>
                          <Select
                            options={[
                              {
                                value: "PARTIALLY_SHIPPED",
                                label: "Partially Shipped",
                              },
                              { value: "SHIPPED", label: "Shipped" },
                              {
                                value: "READY_TO_SHIP",
                                label: "Ready To Ship",
                              },
                            ]}
                            placeholder="Select Status"
                            value={tempStatus}
                            onChange={(value) => {
                              statusChange(value || []);
                            }}
                            maxTagCount="responsive"
                            maxTagTextLength={15}
                          />
                        </div>
                      )}
                    </div>
                  }
                  okText="Apply"
                  cancelText="Cancel"
                  onConfirm={handleApplyFilters}
                  onCancel={handleCancel}
                  icon={false}
                >
                  <Tooltip
                    title="Filters"
                    placement="top"
                    destroyTooltipOnHide={true}
                  >
                    <Button
                      type="primary"
                      className={styles["search-filter__markReceived"]}
                    >
                      <FilterOutlined style={{ fontSize: "20px" }} />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </Col>
              {selectedRowKeys && selectedRowKeys.length > 0 && canDelete && (
                <Col>
                  <Tooltip
                    title="Delete Selected"
                    placement="top"
                    destroyTooltipOnHide={true}
                  >
                    <Button
                      type="primary"
                      danger
                      className={styles["search-filter__delete"]}
                      onClick={handleDeleteClick}
                    >
                      Delete
                      <DeleteOutlined style={{ fontSize: "20px" }} />
                    </Button>
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Col>
          <Col></Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
